import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {ConnectionService} from "./connection.service";
import {Observable} from "rxjs";
import {ResourceTaskTime} from "../entities/ResourceTaskTime";
import {AppConfig} from "../app.config";
import {ApproveEventsModel} from "../entities/ApproveEventsModel";
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class ResourceTaskTimeService {

  private readonly apiUrl: string;

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(private http: Http,
              private connectionService: ConnectionService,
              private config : AppConfig,
              private requestInterceptor: RequestInterceptor) {
    this.apiUrl = config.getConfig('endPointApiUrl') + 'api/ResourceTaskTime/';
  }

  public GetRTTWithGlobalDates(taskGUID, resourceNo, timePlanNo): Observable<ResourceTaskTime> {
    let url = this.apiUrl + 'GetWithGlobalDates/' + taskGUID + "/" + resourceNo + "/" + timePlanNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as ResourceTaskTime);
  }

  public SetApprovedOnRTTsByFilter(model : ApproveEventsModel): Observable<any> {
    let url = this.apiUrl + 'SetApprovedOnRTTsByFilter/';

    return this.http
      .put(url,  JSON.stringify(model), this.getHeaders())
      .map(response => response.json() as any);
  }

  public RemoveAllEventsBasedOnFilter(eventsModel : ApproveEventsModel): Observable<any> {
    let url = this.apiUrl + '/RemoveAllEventsBasedOnFilter/';

    return this.http
      .post(url,  JSON.stringify(eventsModel), this.getHeaders())
      .map(response => response.json() as any);
  }

}







// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/resource-task-time.service.ts